import { createSelector, Selector } from 'reselect'

import {
  networkGroup,
} from './utils'

import {
  IRecord_Marketing_Campaign,
  IData_Marketing_Project_Settings,
  IRecord_Marketing_Post,
  IRecord_Marketing_Connection,
  IData_Network,
} from '@kaidam/fc-shared/src/types/schema/marketing'

import {
  IForm_FlatSchema,
} from '@kaidam/fc-shared/src/types/schema/form'

import {
  IMeta_ProjectConfig_App_Config_Marketing,
} from '@kaidam/fc-shared/src/types/schema/project_config'

import {
  getGodContentSchema,
  isRootOrg,
  getUnlockedGodContentFields,
  getHiddenGodContentFields,
} from '@kaidam/fc-shared/src/utils/marketing'

import {
  IData_Paginated_Results,
} from '@kaidam/fc-shared/src/types/pagination'

import {
  RootState,
} from '../../types/store'

import {
  appConfig,
  currentOrg,
} from './project'

export const campaigns: Selector<RootState, IRecord_Marketing_Campaign[]> = state => state.marketing.campaigns
export const campaignsPagination: Selector<RootState, IData_Paginated_Results> = state => state.marketing.campaignsPagination
export const allPosts: Selector<RootState, IRecord_Marketing_Post[]> = state => state.marketing.allPosts
export const allPostsPagination: Selector<RootState, IData_Paginated_Results> = state => state.marketing.allPostsPagination
export const godContent: Selector<RootState, Record<string, string>> = state => state.marketing.godContent
export const posts: Selector<RootState, IRecord_Marketing_Post[]> = state => state.marketing.posts
export const localPosts: Selector<RootState, IRecord_Marketing_Post[]> = state => state.marketing.local_posts
export const connections: Selector<RootState, IRecord_Marketing_Connection[]> = state => state.marketing.connections

export const projectSettings: Selector<RootState, IData_Marketing_Project_Settings> = createSelector(
  appConfig,
  (configs) => {
    const config = configs.find(c => c.namespace == 'marketing')
    if(!config || !config.config) return
    const c = config.config as IData_Marketing_Project_Settings
    return c
  },
)

export const isRoot: Selector<RootState, boolean> = createSelector(
  currentOrg,
  (org) => {
    return isRootOrg(org)
  },
)

// which org ID do we use to load campaigns?
// if we are not the root org then we go up a level
export const loadCampaignsOrgId: Selector<RootState, string> = createSelector(
  currentOrg,
  (org) => {
    return isRootOrg(org) ? org.id : org.parent_org
  },
)

export const godContentFormInfo: Selector<RootState, {
  schema: IForm_FlatSchema,
  values: Record<string, string>,
  unlockedFields: string[],
  hiddenFields: string[],
  isRoot: boolean,
}> = createSelector(
  projectSettings,
  currentOrg,
  godContent,
  (projectSettings, org, values) => {
    const schema = getGodContentSchema(projectSettings)
    const unlockedFields = getUnlockedGodContentFields(projectSettings)
    const hiddenFields = getHiddenGodContentFields(projectSettings)
    const isRoot = isRootOrg(org)
    return {
      schema,
      unlockedFields,
      hiddenFields,
      isRoot,
      values,
    }
  },
)

export const allNetworks: Selector<RootState, IData_Network[]> = createSelector(
  projectSettings,
  (projectSettings) => {
    const networks = projectSettings.post_templates.reduce<Partial<Record<IData_Network, boolean>>>((acc, template) => {
      acc[template.network] = true
      return acc
    }, {})
    return Object.keys(networks) as IData_Network[]
  },
)

export const network = networkGroup('marketing', [
  'loadCampaigns',
  'loadAllPosts',
])

export default {
  campaigns,
  campaignsPagination,
  posts,
  loadCampaignsOrgId,
  allPosts,
  allPostsPagination,
  localPosts,
  connections,
  godContent,
  projectSettings,
  isRoot,
  godContentFormInfo,
  allNetworks,
  network,
}
